import { fetchWithAuth } from "../utils/fetch/FetchWithAuth";
import { prepareBaseGetListParams } from "../utils/fetch/PrepareBaseGetListParams";

export const DeviceCurrentStateService = {
    getPriceDistribution: (productId, max) => {
        return fetchWithAuth(`/portal/device-current-state/${productId}/price-distribution?max=${max}`, { method: 'GET' });
    },
    getCriticalProductConditionList: (criteria) => {
        const params = prepareBaseGetListParams(criteria);
        return fetchWithAuth(`/portal/device-current-state/critical-product-condition?${params.toString()}`, { method: 'GET' });
    },
    getCriticalProductConditionStatusList: () => {
        return fetchWithAuth('/portal/device-current-state/critical-product-condition-status-list', { method: 'GET' });
    }
}